import {
  getMemberDeathCalendarParts,
  getMemberWeddingCalendarParts,
} from "./family-tree/dateAndTime";

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

/**
 * Month (0–11) and day off a dashboard row's own date text — "November 18
 * (Wednesday) - 21st Anniversary", "September 7 (Monday) - Remembered", or
 * MM/DD/YYYY. null when the text names no day.
 */
export function getDashboardRowMonthDayFromText(dateStr) {
  if (!dateStr || typeof dateStr !== "string") return null;

  const trimmed = dateStr.trim();

  const slashMatch = trimmed.match(/^(\d{1,2})\/(\d{1,2})\/\d{4}/);
  if (slashMatch) {
    return {
      month: parseInt(slashMatch[1], 10) - 1,
      day: parseInt(slashMatch[2], 10),
    };
  }

  for (let monthIndex = 0; monthIndex < MONTH_NAMES.length; monthIndex++) {
    const monthName = MONTH_NAMES[monthIndex];
    if (!trimmed.startsWith(`${monthName} `)) continue;

    const dayMatch = trimmed.slice(monthName.length + 1).match(/^(\d{1,2})/);
    if (!dayMatch) continue;

    return { month: monthIndex, day: parseInt(dayMatch[1], 10) };
  }

  return null;
}

/**
 * Month/day of a wedding anniversary row. The row's own date text comes
 * first — the dashboard's anniversaries list is not confined to the current
 * month (a November couple comes back in September's payload), and the text
 * is the day the endpoint put the row on — with the stored wedding date, read
 * as written, standing in for a roster row, which has no text.
 */
export function getDashboardAnniversaryMonthDay(row) {
  const fromText = getDashboardRowMonthDayFromText(row?.date);
  if (fromText) return fromText;

  const wedding = getMemberWeddingCalendarParts(row);
  return wedding ? { month: wedding.month, day: wedding.day } : null;
}

/** Month/day of an In Memoriam row — its date text first, else the date of death. */
export function getDashboardMemorialMonthDay(row) {
  const fromText = getDashboardRowMonthDayFromText(row?.date);
  if (fromText) return fromText;

  const death = getMemberDeathCalendarParts(row);
  return death ? { month: death.month, day: death.day } : null;
}

/** The anniversary rows that fall in `monthIndex` (0–11). */
export function filterDashboardAnniversariesByMonth(rows, monthIndex) {
  return (rows || []).filter(
    (row) => getDashboardAnniversaryMonthDay(row)?.month === monthIndex
  );
}
